/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useState } from "react";
import RulesSection, { ServiceNotificationStatus } from "../ServicesRules/RulesSection";
import { fetchCustomersServices, fetchTemplatesList } from "../requests/request";
import { useAxiosAuth0 } from "@shared/config/useAxiosAuth0";
import { useProcessingOverlay } from "@shared/hooks/useProcessingOverlay";
import { useAppSelector } from "@redux/hooks";
import { RawCustomer, ServiceItem } from "../hooks/useCustomers";

interface OrganizationalProps {
  isOrgConfigEnabled: boolean;
  onOrgConfigChange: (enabled: boolean) => void;
}

export default function Organizational({
  isOrgConfigEnabled,
  onOrgConfigChange,
}: OrganizationalProps) {
  const tenantId = useAppSelector(s => s.selection.tenantId);

  const [allServices, setAllServices] = useState<ServiceItem[]>([]);
  const [loading,     setLoading]     = useState(true);
  const [error,       setError]       = useState<string|null>(null);

  const [portNotificationStates, setPortNotificationStates] = useState<ServiceNotificationStatus[]>([]);
  const [internetNotificationStates, setInternetNotificationStates] = useState<ServiceNotificationStatus[]>([]);
  const [portTemplates, setPortTemplates] = useState<any[]>([]);
  const [internetTemplates, setInternetTemplates] = useState<any[]>([]);


  const api = useAxiosAuth0();
  const overlaySpinner = useProcessingOverlay(loading);

  useEffect(() => {
    if (!tenantId) {
      setAllServices([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
  
    fetchCustomersServices(api, tenantId)
      .then(resp => {
        const raw = resp.data.data as RawCustomer[];
        const flat: ServiceItem[] = [];
        raw.forEach(cust => {
          [ ...cust.services.ports,
            ...cust.services.internet,
            ...cust.services.cloudConnectivity
          ].forEach(svc => {
            flat.push({
              id: svc.id,
              name: svc.name,
              subscriptionId: svc.subscriptionId,
              type: svc.type,
              customer: {
                id: cust.id,
                name: cust.nameDisplay ?? cust.name,
              }
            });
          });
        });
        setAllServices(flat);
      })
      .catch(err => {
        console.error(err);
        setError("Unable to load your services. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [api, tenantId]);

  const portServices     = useMemo(
    () => allServices.filter(s => s.type === "port"),
    [allServices]
  );
  const internetServices = useMemo(
    () => allServices.filter(s => s.type === "internet"),
    [allServices]
  );


    useEffect(() => {
      const fetchData = async () => {
        try {
          const resp = await fetchTemplatesList(api);
          const templates = resp.data?.data?.templates ?? [];
          const enabledTemplates = templates.filter((t: { enabled: any; }) => t.enabled);
          setPortTemplates(
            enabledTemplates.filter((t: { compatibleServices: string | string[]; }) => t.compatibleServices.includes("port"))
          );
          setInternetTemplates(
            enabledTemplates.filter((t: { compatibleServices: string | string[]; }) => t.compatibleServices.includes("internet"))
          );
        } catch (err) {
          console.error("Error fetching templates:", err);
        } finally {
          setLoading(false);
        }
      };
    
      fetchData();
    }, [api]);


  if (loading) {
    return overlaySpinner;
  }

  return (
    <div className="space-y-6">
      {/* <GenericCard
        headerContent="Default recipients"
        isCollapsible={false}
        rightContent={
          <p className="text-xs text-semantic-text-secondary">
            Add external users who are not registered in the platform
          </p>
        }
        bodyContent={
          <DefaultRecipientsManager
            initialRecipients={emails}
            onRecipientsChange={setEmails}
          />
        }
      /> */}
      <RulesSection
        title="Port Rules"
        type="port"
        services={portServices}
        customers={[]}
        notificationStates={portNotificationStates}
        templates={portTemplates}
        isReadOnly={false}
        initialExpanded={true}
        subscriberType="tenant"
        subscriberId={String(tenantId)}
        sendTenantId={true}
        showManageRecipients={true}

      />
      <RulesSection
        title="Internet Rules"
        type="internet"
        services={internetServices}
        customers={[]}
        templates={internetTemplates}
        notificationStates={internetNotificationStates}
        isReadOnly={false}
        initialExpanded={true}
        subscriberType="tenant"
        subscriberId={String(tenantId)}
        sendTenantId={true}
        showManageRecipients={true}

      />
    </div>
  );   
}
